import { render } from "./SearchForm.vue?vue&type=template&id=1d52499c&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=1d52499c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d52499c"

export default script